import axios from 'axios';
import BaseAPI from './base/base-api';

class AuditingLogAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'auditinglog';

}

export default new AuditingLogAPI();